import WIDGETS from './widgets';

export default {
	name: 'analytic_tickets_logs',
	spacing: 2,
	widgets: [{ content: WIDGETS.ANALYTIC_TICKETS_LOGS, breakpoints: { xs: 12 }, lazy_loading: 0 }],
};
